import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20c14384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-text": "Тайлан боловсруулж байна..." }
const _hoisted_2 = { class: "card card-stretch shadow report-breadcrumb" }
const _hoisted_3 = { class: "card-body report-breadcrumb__body" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Тайлан")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Үндсэн тайлан")
const _hoisted_7 = { class: "report-shell shadow" }
const _hoisted_8 = { class: "report-hero" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-kicker" }, "Зээлийн мэдээллийн сан", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Үндсэн тайлан", -1))
const _hoisted_11 = { class: "report-scope" }
const _hoisted_12 = { class: "report-controls" }
const _hoisted_13 = { class: "report-control-row report-control-row--main" }
const _hoisted_14 = { class: "control-block" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Тайлангийн төрөл", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Үлдэгдэлтэй")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Нийлүүлсэн")
const _hoisted_18 = { class: "control-block" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Бүтээгдэхүүн", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Зээл")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Зээлийн шугам")
const _hoisted_22 = { class: "control-block control-block--date" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Хамрах хугацаа", -1))
const _hoisted_24 = {
  key: 0,
  class: "report-control-row report-control-row--org"
}
const _hoisted_25 = { class: "control-block" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Байгууллагын төрөл", -1))
const _hoisted_27 = { class: "control-block" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Байгууллага", -1))
const _hoisted_29 = { class: "report-summary" }
const _hoisted_30 = { class: "summary-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Сонгосон тайлан", -1))
const _hoisted_32 = { class: "summary-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Хугацааны дүрэм", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-item" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Формат"),
  /*#__PURE__*/_createElementVNode("strong", null, "XLSX")
], -1))
const _hoisted_35 = { class: "report-actions" }
const _hoisted_36 = ["disabled", "data-kt-indicator"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel" })
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(_ctx.scopeText), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.supervisor ? _ctx.selectedOrgLabel : _ctx.orgcode), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.supervisor ? _ctx.selectedOrgCodeLabel : _ctx.orgname), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_radio_group, {
              class: "segmented-control",
              modelValue: _ctx.reportKind,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportKind) = $event)),
              size: "small",
              onChange: _ctx.handleKindChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, { label: "outstanding" }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio_button, { label: "supplied" }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_el_radio_group, {
              class: "segmented-control",
              modelValue: _ctx.productType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productType) = $event)),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, { label: "loan" }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio_button, { label: "line" }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.dateRange,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateRange) = $event)),
              type: "daterange",
              size: "small",
              "range-separator": "-",
              "start-placeholder": "Эхлэх огноо",
              "end-placeholder": "Дуусах огноо",
              "value-format": "YYYY-MM-DD",
              disabled: _ctx.dateRangeDisabled,
              onChange: _ctx.handleDateRangeChange,
              style: {"width":"100%"}
            }, null, 8, ["modelValue", "disabled", "onChange"])
          ])
        ]),
        (_ctx.supervisor)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.orgTypeValue,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orgTypeValue) = $event)),
                  size: "small",
                  placeholder: "Бүгд",
                  style: {"width":"100%"},
                  onChange: _ctx.handleOrgTypeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgTypes, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.orgcodeValue,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orgcodeValue) = $event)),
                  size: "small",
                  filterable: "",
                  clearable: "",
                  placeholder: "Бүгд",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.admin)
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          value: "*",
                          label: "Бүгд"
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrgList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("strong", null, _toDisplayString(_ctx.selectedReportName), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("strong", null, _toDisplayString(_ctx.intervalText), 1)
        ]),
        _hoisted_34
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("button", {
          class: "el-button el-button--primary el-button--small",
          disabled: _ctx.downloading,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args))),
          "data-kt-indicator": _ctx.downloading ? 'on' : 'off'
        }, _hoisted_39, 8, _hoisted_36)
      ])
    ])
  ])), [
    [
      _directive_loading,
      _ctx.downloading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}